import { Component, Input, OnInit } from '@angular/core';
import { Offer } from '../../../../../../core/models/offer/offer.model';
import { LanguageService } from '../../../../../services/language.service';
import { OfferCoverage } from '../../../../../../core/models/offer/offer-coverage.model';
import {isNext} from '../../../../../../core/utils/utils';
import {OfferDestinyOptionType} from '../../../../../../core/enums/offer/offer-destiny-option-type.enum';

@Component({
  selector: 'app-offer-presentation-group-box',
  templateUrl: './offer-presentation-group-box.component.html',
  styleUrls: ['./offer-presentation-group-box.component.scss']
})
export class OfferPresentationGroupBoxComponent implements OnInit {

  @Input() offers: Offer[];
  @Input() groupOffer: any;

  title: string;
  groupCollapsed: boolean = false;
  isNext = isNext();

  constructor(private language: LanguageService) {
  }

  ngOnInit() {
    this.setTitle();
    // this.setGroupCollapsed();
  }

  setTitle() {
    this.title = this.getTranslationForParameter(this.groupOffer.groupNames, 'name');
  }

  getTranslationForParameter(arr: any[], key: string): string {
    return this.language.getTranslationForKey(arr, key)
  }

  getTooltipTranslation(coverage: any): string {
    return this.getTranslationForParameter(coverage, 'tooltip')
  }

  findCoverage(coverages: OfferCoverage[], codeToFind: string) {

    const filtered = coverages.filter(({ code }) => code === codeToFind);
    if (filtered.length === 0) {
      console.warn(`There is no coverageGroups coverage ${codeToFind} in offer coverages ${coverages.map(({code}) => code)}`);
      return;
    }
    const dest = filtered.flatMap(({ destinies }) => destinies.filter(({ code }) => code === 'COMPARE'));
    return dest[0];
  }

  private setGroupCollapsed(): void {
    const groupCoveragesCodes: string[] = this.groupOffer.coverages.map(coverage => coverage.code);
    const selectedOptions = this.offers
      .flatMap(offer => offer.coverages)
      .filter(coverage => groupCoveragesCodes.includes(coverage.code))
      .flatMap(({ destinies }) => destinies.filter(({ code }) => code === 'COMPARE'))
      .map(destiny => destiny.options.find(option => destiny.selectedOption === option.code));
    const selectedFalseOptions = selectedOptions.filter(option => option.type === OfferDestinyOptionType.BOOLEAN && !this.language.getBooleanOption(option.values));

    this.groupCollapsed = selectedFalseOptions.length === selectedOptions.length;
  }

}
